import type { GroupMember } from '@percent/admin-dashboard/api/actions/groups/groups.types'

export const mockGroupMembers: GroupMember[] = [
  {
    type: 'account',
    id: 'account_001',
    email: 'john.smith@example.com',
    fullName: 'John Smith',
    role: 'member',
    addedAt: '2024-01-01T00:00:00Z'
  },
  {
    type: 'account',
    id: 'account_002',
    email: 'jane.doe@example.com',
    fullName: 'Jane Doe',
    role: 'owner',
    addedAt: '2024-01-02T00:00:00Z'
  },
  {
    type: 'group',
    id: 'group_002',
    name: 'Pops (Compliance)',
    role: 'member',
    addedAt: '2024-01-03T00:00:00Z'
  },
  {
    type: 'account',
    id: 'account_003',
    email: 'james.johnson@example.com',
    fullName: 'James Johnson',
    role: 'maintainer',
    addedAt: '2024-01-04T00:00:00Z'
  },
  {
    type: 'account',
    id: 'account_004',
    email: 'mary.williams@example.com',
    fullName: 'Mary Williams',
    role: 'member',
    addedAt: '2024-01-05T00:00:00Z'
  },
  {
    type: 'group',
    id: 'group_003',
    name: 'Pops (Payments)',
    role: 'member',
    addedAt: '2024-01-06T00:00:00Z'
  },
  {
    type: 'account',
    id: 'account_005',
    email: 'robert.brown@example.com',
    fullName: 'Robert Brown',
    role: 'maintainer',
    addedAt: '2024-01-07T00:00:00Z'
  },
  {
    type: 'account',
    id: 'account_006',
    email: 'patricia.jones@example.com',
    fullName: 'Patricia Jones',
    role: 'member',
    addedAt: '2024-01-08T00:00:00Z'
  },
  {
    type: 'account',
    id: 'account_007',
    email: 'linda.miller@example.com',
    fullName: 'Linda Miller',
    role: 'member',
    addedAt: '2024-01-09T00:00:00Z'
  }
]

export const mockGroupMembersResponse = {
  data: mockGroupMembers,
  totalResults: mockGroupMembers.length
}
